import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../redux/store';
import {searchItem} from '../api/checkout.api';
// Define a type for the slice state

type PromoList = {
  discountAmount: number;
  promoDesc: string;
  promoID: string;
};

type PriceList = {
  sellPrice: number;
  discountAmount: number;
  extSellPrice: number;
  promoList: PromoList[];
};
type ItemDetail = {
  itemID: string;
  itemDesc: string;
  itemDept: string;
  itemBrand: string;
  itemColour: string;
  itemSize: string;
  mmrpFlag: string;
  priceList: PriceList[];
};

type ItemInformation = {
  statusCode: string;
  message: string;
  storeID: string;
  orderID: string;
  itemDetail: ItemDetail[];
};
interface CheckoutState {
  loading: boolean;
  error: string;
  itemInformation: ItemInformation | null;
}

// Define the initial state using that type
const initialState: CheckoutState = {
  loading: false,
  error: '',
  itemInformation: null,
};

export const fetchItemInformation = createAsyncThunk(
  'searchItem/fetchItemInformation',
  async (parameters: any, thunkApi) => {
    return searchItem(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const searchItemSlice = createSlice({
  name: 'searchItemSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetItemInformation: state => {
      state.itemInformation = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchItemInformation.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchItemInformation.fulfilled, (state, {payload}) => {
      state.itemInformation = payload;
      state.loading = false;
    });
    builder.addCase(fetchItemInformation.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
  },
});

// Other code such as selectors can use the imported `RootState` type
export const {resetItemInformation} = searchItemSlice.actions;

export const itemInformation = (state: RootState): ItemInformation | null =>
  state.searchItemReducer.itemInformation;

export default searchItemSlice.reducer;
